import React, { useState } from "react";
import { useSelector } from "react-redux";
import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  CardElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { useParams } from "react-router-dom";

const stripePromise = loadStripe("your_stripe_public_key"); // Replace with your Stripe public key
function Book() {
  const listings = useSelector((state) => state.appContext.listings);
  const { id } = useParams();
  const listing = listings.find((listing) => listing.id === Number(id));
  let owner;
  let ownerName;
  let carName;
  let imageUrl;
  let profileUrl;
  if (listing) {
    owner = listing.owner;
    ownerName = owner.first_name + " " + owner.last_name;
    carName =
      listing.vehicle.brand +
      " " +
      listing.vehicle.model +
      " " +
      listing.vehicle.year;
    imageUrl = listing.mainPicture.url;
    profileUrl = listing.owner.profilePicture.url;
  }
  return (
    <div>
      <container className="jcc onDesktop">
        <pagewrapper>
          <row>
            <h2>Checkout</h2>
          </row>
          <row className="aic iconGap my-l" name="free cancellation">
            <svg
              width={20}
              height={19}
              viewBox="0 0 20 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.8898 9.41455H13.2148V17.1596H18.8898V9.41455Z"
                fill="#D8FFCA"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.095 7.1995L12.62 9.6375V17.1595C12.62 17.5045 12.9 17.7845 13.245 17.7845H18.895C19.24 17.7845 19.52 17.5045 19.52 17.1595V9.4145C19.52 9.0695 19.24 8.7895 18.895 8.7895H13.56L12.155 6.5395C11.66 5.7545 11.305 4.8595 11.1 3.8795L10.555 1.3195C10.455 0.934497 10.195 0.609496 9.84 0.419496C9.485 0.229496 9.07 0.204497 8.685 0.349497C7.49 0.839497 6.8 2.0545 7.005 3.2795L7.3725 5.965C6.63 5.9425 5.6795 5.94 4.3825 5.94L4.375 5.9395H2.575C1.43 5.9395 0.5 6.8695 0.5 8.0145C0.5 8.4645 0.64 8.8795 0.885 9.2145C0.35 9.5895 0 10.2145 0 10.9145C0 11.6145 0.35 12.2395 0.885 12.6145C0.64 12.9545 0.5 13.3695 0.5 13.8145C0.5 14.5195 0.85 15.1395 1.385 15.5145C1.14 15.8545 1 16.2695 1 16.7145C1.00048 17.2152 1.18183 17.6989 1.51064 18.0765C1.83946 18.4541 2.29362 18.7002 2.7895 18.7695C2.8395 18.7825 2.8915 18.7895 2.945 18.7895H4.54C8.955 18.7895 9.24 18.7495 11.29 17.8945C11.61 17.7595 11.76 17.3945 11.625 17.0745C11.49 16.7545 11.12 16.6095 10.805 16.7395C8.928 17.523 8.842 17.5395 4.043 17.5395H3.075C2.62 17.5395 2.25 17.1695 2.25 16.7145C2.25 16.2595 2.62 15.8895 3.075 15.8895C3.24076 15.8895 3.39973 15.8236 3.51694 15.7064C3.63415 15.5892 3.7 15.4303 3.7 15.2645C3.7 15.0987 3.63415 14.9398 3.51694 14.8226C3.39973 14.7053 3.24076 14.6395 3.075 14.6395H2.575C2.12 14.6395 1.75 14.2695 1.75 13.8145C1.75 13.3595 2.12 12.9895 2.575 12.9895C2.74076 12.9895 2.89973 12.9236 3.01694 12.8064C3.13415 12.6892 3.2 12.5303 3.2 12.3645C3.2 12.1987 3.13415 12.0398 3.01694 11.9226C2.89973 11.8053 2.74076 11.7395 2.575 11.7395H2.075C1.62 11.7395 1.25 11.3695 1.25 10.9145C1.25 10.4595 1.62 10.0895 2.075 10.0895H2.575C2.74076 10.0895 2.89973 10.0236 3.01694 9.90644C3.13415 9.78923 3.2 9.63026 3.2 9.4645C3.2 9.29874 3.13415 9.13976 3.01694 9.02255C2.89973 8.90534 2.74076 8.8395 2.575 8.8395C2.12 8.8395 1.75 8.4695 1.75 8.0145C1.75 7.5595 2.12 7.1895 2.575 7.1895H3.835C5.8715 7.1895 7.113 7.1895 7.981 7.246C8.07827 7.26269 8.17811 7.25637 8.2725 7.22755C8.36689 7.19872 8.45322 7.14819 8.52457 7.08C8.59592 7.01181 8.65031 6.92785 8.68338 6.83486C8.71644 6.74187 8.72728 6.64243 8.715 6.5445L8.245 3.0895C8.135 2.4145 8.5 1.7745 9.145 1.5095C9.193 1.4905 9.236 1.508 9.2615 1.518L9.265 1.5195C9.305 1.5445 9.335 1.5795 9.34 1.5945L9.88 4.1345C10.115 5.2545 10.525 6.2845 11.095 7.1995ZM13.87 16.5345H18.27V10.0395H13.87V16.5345Z"
                fill="#76B60F"
              />
            </svg>
            <div>
              <h5 className style={{ color: "black", fontWeight: 900 }}>
                Free cancellation before July 23, 10:00 AM
              </h5>
              <h7 style={{ color: "black", fontWeight: 0, fontSize: 12 }}>
                If your plans change, we’ve got your back.
              </h7>
            </div>
          </row>
          <container className="onDesktop">
            <div className="chkPanel jcs">
              <line />
              <row>
                {" "}
                <h5 className>Extras</h5>
              </row>
              <row>
                <p className>
                  These optional Extras are offered by this host and can help
                  make your trip unique and memorable.
                </p>
              </row>
              <row>
                {" "}
                <h6 className>CONVINIENCE</h6>
              </row>
              <roundedcard className="highlight">
                <row className="jcb">
                  <h4>Prepaid refuel</h4>
                  <p>$50/trip</p>
                </row>
                <row className="mt-m">
                  <p>
                    Save time, make drop-off a breeze, and avoid additional fees
                    by adding this Extra, which allows you to return my car at
                    any fuel level. Price includes up to a full tank of gas.
                  </p>
                </row>
                <row className="jce mt-1">
                  <h5 className="mt-1" style={{ color: "#76b60f" }}>
                    Remove
                  </h5>
                </row>
              </roundedcard>
              <h6>No thanks, I don't want to add any Extras</h6>
              <squarebutton className="greenButton">Continue</squarebutton>
              <line className="mt-1" />
              <h5>Protection plans</h5>
              <line className="mt-1" />
              <h5>Payment methods</h5>
              <h6 className="mt-1">
                You’ll be able to message MRA Car Rentals after checkout.
              </h6>
              <h6 className="mt-1">
                By selecting book this trip, you agree to pay the total shown
                and to the Wheely terms of service and cancellation policy.
              </h6>
              <squarebutton className="greenButton mt-2 rounded">
                Book this trip
              </squarebutton>
            </div>
            <div className="chkSlider">
              <roundedcard>
                <selectioncard
                  className="relative"
                  style={{ backgroundImage: `url(${imageUrl})` }}
                >
                  <profileratedbox
                    className="absolute"
                    style={{ bottom: "-5px", right: "-15%" }}
                  >
                    <img
                      src={profileUrl}
                      alt="profile"
                      style={{ height: 80, width: 80, borderRadius: "50%" }}
                    />
                    <container
                      name="ratingBox"
                      className="absolute aic"
                      style={{ right: "-5%", bottom: -10 }}
                    >
                      <cardlabel className="aic">
                        <container className="aic" style={{ columnGap: 4 }}>
                          <p style={{ textAlign: "center" }}>5.0</p>
                          <svg
                            width={14}
                            height={14}
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M9.10227 4.45443L13.0393 4.72843C13.6423 4.77043 13.8893 5.52543 13.4273 5.91643L10.4143 8.47343L11.3323 12.2874C11.3638 12.4174 11.356 12.5538 11.3098 12.6793C11.2636 12.8048 11.1811 12.9138 11.0728 12.9923C10.9646 13.0708 10.8354 13.1152 10.7017 13.1201C10.568 13.1249 10.436 13.0899 10.3223 13.0194L7.00027 10.9564L3.67827 13.0194C3.56459 13.0899 3.43251 13.1249 3.29885 13.1201C3.16519 13.1152 3.036 13.0708 2.9277 12.9923C2.81941 12.9138 2.73691 12.8048 2.69071 12.6793C2.64451 12.5538 2.6367 12.4174 2.66827 12.2874L3.58827 8.47343L0.576275 5.92143C0.473311 5.83543 0.398308 5.7207 0.360842 5.59188C0.323376 5.46306 0.325144 5.326 0.365923 5.19819C0.406701 5.07038 0.484639 4.95763 0.589789 4.87431C0.694938 4.791 0.822529 4.7409 0.956275 4.73043L4.89327 4.45443L6.37727 0.872429C6.42814 0.749314 6.5144 0.644065 6.62513 0.570008C6.73585 0.495952 6.86607 0.456421 6.99927 0.456421C7.13248 0.456421 7.2627 0.495952 7.37342 0.570008C7.48415 0.644065 7.57041 0.749314 7.62127 0.872429L9.10127 4.45443H9.10227Z"
                              fill="#121214"
                            />
                          </svg>
                        </container>
                      </cardlabel>
                    </container>
                  </profileratedbox>
                </selectioncard>
                <h6 className="mt-l">Wheely’s</h6>
                <h5 className style={{ marginTop: 2 }}>
                  {carName}
                </h5>
                <h6 className="mt-1">5.0 (56 Trips)</h6>
                <row className="my-l jcb">
                  <column>
                    <h5>Weds, Jul 4</h5>
                    <h6>10:00 AM</h6>
                  </column>
                  <h5>=&gt;</h5>
                  <column>
                    <h5>Sat, Jul 26</h5>
                    <row className="jce">
                      <h6>10:00 AM</h6>
                    </row>
                  </column>
                </row>
                <line />
                <h5 className="my-l">Meeting location</h5>
                <row className="aic" style={{ columnGap: 8 }}>
                  <svg
                    width="17.454545456px"
                    height="17.454545456px"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="css-1o6k71p"
                    role="img"
                    version="1.1"
                  >
                    <path
                      d="M18.86 7.3c.1.24.33.38.57.38.09 0 .17-.02.24-.06.32-.14.47-.5.33-.82l-1.42-3.29a2.285 2.285 0 0 0-2.1-1.38H7.51c-.92 0-1.74.54-2.1 1.38L3.99 6.8c-.13.32.02.68.33.82.31.14.68 0 .82-.32l1.42-3.29c.16-.37.54-.62.95-.62h8.98c.41 0 .79.24.95.62l1.42 3.29ZM19.49 13.92a1.6 1.6 0 1 1-3.2 0 1.6 1.6 0 0 1 3.2 0ZM6.11 15.52a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2Z"
                      fill="#76B60F"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M15.43 18.69H8.55v2.4c.02.69-.54 1.25-1.23 1.25H4.91c-.69 0-1.25-.56-1.25-1.25v-2.413a2.545 2.545 0 0 1-2.28-2.527V11.7c0-1.4 1.14-2.54 2.54-2.54h16.17c1.4 0 2.54 1.14 2.54 2.54v4.45a2.552 2.552 0 0 1-2.3 2.528v2.412c.02.69-.54 1.25-1.24 1.25h-2.41c-.69 0-1.25-.56-1.25-1.25v-2.4Zm3.66 0h-2.42v2.4h2.42v-2.4Zm-14.19 0h2.41v2.4H4.9v-2.4Zm-2.27-7c0-.71.58-1.29 1.29-1.29v.01h16.17c.71 0 1.29.58 1.29 1.29v4.44c0 .71-.58 1.29-1.29 1.29H3.92c-.71 0-1.29-.58-1.29-1.29v-4.45Z"
                      fill="#76B60F"
                    />
                  </svg>
                  <h6>Lake Worth, FL 33461</h6>
                </row>
                <row className="mt-l jcb">
                  <p>$33.67 x 3 days</p>
                  <p>$101.00</p>
                </row>
                <row className="mt-l jcb">
                  <p>Trips fee</p>
                  <p>$101.00</p>
                </row>
                <row className="mt-l jcb">
                  <p>Sales tax</p>
                  <p>$101.00</p>
                </row>
                <row className="mt-l jcb">
                  <p>Prepaid fuel</p>
                  <p>$101.00</p>
                </row>
                <row className="mt-l jcb">
                  <p>900 total miles</p>
                  <p>FREE</p>
                </row>
                <highlightbox className="mt-l jcb">
                  <h5>Total</h5>
                  <h5>$140.18</h5>
                </highlightbox>
                <row className="aic iconGap my-l" name="free cancellation">
                  <div>
                    <svg
                      width={20}
                      height={19}
                      viewBox="0 0 20 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18.8898 9.41455H13.2148V17.1596H18.8898V9.41455Z"
                        fill="#D8FFCA"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M11.095 7.1995L12.62 9.6375V17.1595C12.62 17.5045 12.9 17.7845 13.245 17.7845H18.895C19.24 17.7845 19.52 17.5045 19.52 17.1595V9.4145C19.52 9.0695 19.24 8.7895 18.895 8.7895H13.56L12.155 6.5395C11.66 5.7545 11.305 4.8595 11.1 3.8795L10.555 1.3195C10.455 0.934497 10.195 0.609496 9.84 0.419496C9.485 0.229496 9.07 0.204497 8.685 0.349497C7.49 0.839497 6.8 2.0545 7.005 3.2795L7.3725 5.965C6.63 5.9425 5.6795 5.94 4.3825 5.94L4.375 5.9395H2.575C1.43 5.9395 0.5 6.8695 0.5 8.0145C0.5 8.4645 0.64 8.8795 0.885 9.2145C0.35 9.5895 0 10.2145 0 10.9145C0 11.6145 0.35 12.2395 0.885 12.6145C0.64 12.9545 0.5 13.3695 0.5 13.8145C0.5 14.5195 0.85 15.1395 1.385 15.5145C1.14 15.8545 1 16.2695 1 16.7145C1.00048 17.2152 1.18183 17.6989 1.51064 18.0765C1.83946 18.4541 2.29362 18.7002 2.7895 18.7695C2.8395 18.7825 2.8915 18.7895 2.945 18.7895H4.54C8.955 18.7895 9.24 18.7495 11.29 17.8945C11.61 17.7595 11.76 17.3945 11.625 17.0745C11.49 16.7545 11.12 16.6095 10.805 16.7395C8.928 17.523 8.842 17.5395 4.043 17.5395H3.075C2.62 17.5395 2.25 17.1695 2.25 16.7145C2.25 16.2595 2.62 15.8895 3.075 15.8895C3.24076 15.8895 3.39973 15.8236 3.51694 15.7064C3.63415 15.5892 3.7 15.4303 3.7 15.2645C3.7 15.0987 3.63415 14.9398 3.51694 14.8226C3.39973 14.7053 3.24076 14.6395 3.075 14.6395H2.575C2.12 14.6395 1.75 14.2695 1.75 13.8145C1.75 13.3595 2.12 12.9895 2.575 12.9895C2.74076 12.9895 2.89973 12.9236 3.01694 12.8064C3.13415 12.6892 3.2 12.5303 3.2 12.3645C3.2 12.1987 3.13415 12.0398 3.01694 11.9226C2.89973 11.8053 2.74076 11.7395 2.575 11.7395H2.075C1.62 11.7395 1.25 11.3695 1.25 10.9145C1.25 10.4595 1.62 10.0895 2.075 10.0895H2.575C2.74076 10.0895 2.89973 10.0236 3.01694 9.90644C3.13415 9.78923 3.2 9.63026 3.2 9.4645C3.2 9.29874 3.13415 9.13976 3.01694 9.02255C2.89973 8.90534 2.74076 8.8395 2.575 8.8395C2.12 8.8395 1.75 8.4695 1.75 8.0145C1.75 7.5595 2.12 7.1895 2.575 7.1895H3.835C5.8715 7.1895 7.113 7.1895 7.981 7.246C8.07827 7.26269 8.17811 7.25637 8.2725 7.22755C8.36689 7.19872 8.45322 7.14819 8.52457 7.08C8.59592 7.01181 8.65031 6.92785 8.68338 6.83486C8.71644 6.74187 8.72728 6.64243 8.715 6.5445L8.245 3.0895C8.135 2.4145 8.5 1.7745 9.145 1.5095C9.193 1.4905 9.236 1.508 9.2615 1.518L9.265 1.5195C9.305 1.5445 9.335 1.5795 9.34 1.5945L9.88 4.1345C10.115 5.2545 10.525 6.2845 11.095 7.1995ZM13.87 16.5345H18.27V10.0395H13.87V16.5345Z"
                        fill="#76B60F"
                      />
                    </svg>
                  </div>
                  <div>
                    <h5 style={{ fontSize: 14 }}>
                      Free cancellation before July 23, 10:00 AM
                    </h5>
                    <h6 className="mt-1" style={{ fontSize: 12 }}>
                      If your plans change, we’ve got your back.
                    </h6>
                  </div>
                </row>
              </roundedcard>
            </div>
          </container>
        </pagewrapper>
      </container>
      <container className="jcc onMobile">
        <mobilewrapper>
          <row>
            <h3>Checkout</h3>
          </row>
          <row className="jcb">
            <column>
              <h6 className="mt-l">{ownerName}’s</h6>
              <h5 className style={{ marginTop: 2 }}>
                {carName}
              </h5>
              <h6 className="mt-1">5.0 (56 Trips)</h6>
              <row className="my-l jcb" style={{ width: 250 }}>
                <column>
                  <h5>Weds, Jul 4</h5>
                  <h6>10:00 AM</h6>
                </column>
                <h5>=&gt;</h5>
                <column>
                  <h5>Sat, Jul 26</h5>
                  <row className="jce">
                    <h6>10:00 AM</h6>
                  </row>
                </column>
              </row>
            </column>
            <selectioncard
              className="relative"
              style={{ backgroundImage: `url(${imageUrl})` }}
            >
              <profileratedbox
                className="absolute"
                style={{ bottom: "-45px", right: "0%" }}
              >
                <img
                  src={profileUrl}
                  alt="profile"
                  style={{ height: 60, width: 60, borderRadius: "50%" }}
                />
                <container
                  name="ratingBox"
                  className="absolute aic"
                  style={{ right: "12%", bottom: "-20px" }}
                >
                  <cardlabel className="aic">
                    <container className="aic" style={{ columnGap: 4 }}>
                      <p style={{ textAlign: "center" }}>5.0</p>
                      <svg
                        width={14}
                        height={14}
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M9.10227 4.45443L13.0393 4.72843C13.6423 4.77043 13.8893 5.52543 13.4273 5.91643L10.4143 8.47343L11.3323 12.2874C11.3638 12.4174 11.356 12.5538 11.3098 12.6793C11.2636 12.8048 11.1811 12.9138 11.0728 12.9923C10.9646 13.0708 10.8354 13.1152 10.7017 13.1201C10.568 13.1249 10.436 13.0899 10.3223 13.0194L7.00027 10.9564L3.67827 13.0194C3.56459 13.0899 3.43251 13.1249 3.29885 13.1201C3.16519 13.1152 3.036 13.0708 2.9277 12.9923C2.81941 12.9138 2.73691 12.8048 2.69071 12.6793C2.64451 12.5538 2.6367 12.4174 2.66827 12.2874L3.58827 8.47343L0.576275 5.92143C0.473311 5.83543 0.398308 5.7207 0.360842 5.59188C0.323376 5.46306 0.325144 5.326 0.365923 5.19819C0.406701 5.07038 0.484639 4.95763 0.589789 4.87431C0.694938 4.791 0.822529 4.7409 0.956275 4.73043L4.89327 4.45443L6.37727 0.872429C6.42814 0.749314 6.5144 0.644065 6.62513 0.570008C6.73585 0.495952 6.86607 0.456421 6.99927 0.456421C7.13248 0.456421 7.2627 0.495952 7.37342 0.570008C7.48415 0.644065 7.57041 0.749314 7.62127 0.872429L9.10127 4.45443H9.10227Z"
                          fill="#121214"
                        />
                      </svg>
                    </container>
                  </cardlabel>
                </container>
              </profileratedbox>
            </selectioncard>
          </row>
          <line />
          <row>
            <h5 className="mt-l">Meeting location</h5>
          </row>
          <row className="aic" style={{ columnGap: 8, marginTop: 12 }}>
            <svg
              width="17.454545456px"
              height="17.454545456px"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="css-1o6k71p"
              role="img"
              version="1.1"
            >
              <path
                d="M18.86 7.3c.1.24.33.38.57.38.09 0 .17-.02.24-.06.32-.14.47-.5.33-.82l-1.42-3.29a2.285 2.285 0 0 0-2.1-1.38H7.51c-.92 0-1.74.54-2.1 1.38L3.99 6.8c-.13.32.02.68.33.82.31.14.68 0 .82-.32l1.42-3.29c.16-.37.54-.62.95-.62h8.98c.41 0 .79.24.95.62l1.42 3.29ZM19.49 13.92a1.6 1.6 0 1 1-3.2 0 1.6 1.6 0 0 1 3.2 0ZM6.11 15.52a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2Z"
                fill="#76B60F"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.43 18.69H8.55v2.4c.02.69-.54 1.25-1.23 1.25H4.91c-.69 0-1.25-.56-1.25-1.25v-2.413a2.545 2.545 0 0 1-2.28-2.527V11.7c0-1.4 1.14-2.54 2.54-2.54h16.17c1.4 0 2.54 1.14 2.54 2.54v4.45a2.552 2.552 0 0 1-2.3 2.528v2.412c.02.69-.54 1.25-1.24 1.25h-2.41c-.69 0-1.25-.56-1.25-1.25v-2.4Zm3.66 0h-2.42v2.4h2.42v-2.4Zm-14.19 0h2.41v2.4H4.9v-2.4Zm-2.27-7c0-.71.58-1.29 1.29-1.29v.01h16.17c.71 0 1.29.58 1.29 1.29v4.44c0 .71-.58 1.29-1.29 1.29H3.92c-.71 0-1.29-.58-1.29-1.29v-4.45Z"
                fill="#76B60F"
              />
            </svg>
            <h6>Lake Worth, FL 33461</h6>
          </row>
          <line className="my-l" />
          <row className="aic iconGap" name="free cancellation">
            <svg
              width={20}
              height={19}
              viewBox="0 0 20 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.8898 9.41455H13.2148V17.1596H18.8898V9.41455Z"
                fill="#D8FFCA"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.095 7.1995L12.62 9.6375V17.1595C12.62 17.5045 12.9 17.7845 13.245 17.7845H18.895C19.24 17.7845 19.52 17.5045 19.52 17.1595V9.4145C19.52 9.0695 19.24 8.7895 18.895 8.7895H13.56L12.155 6.5395C11.66 5.7545 11.305 4.8595 11.1 3.8795L10.555 1.3195C10.455 0.934497 10.195 0.609496 9.84 0.419496C9.485 0.229496 9.07 0.204497 8.685 0.349497C7.49 0.839497 6.8 2.0545 7.005 3.2795L7.3725 5.965C6.63 5.9425 5.6795 5.94 4.3825 5.94L4.375 5.9395H2.575C1.43 5.9395 0.5 6.8695 0.5 8.0145C0.5 8.4645 0.64 8.8795 0.885 9.2145C0.35 9.5895 0 10.2145 0 10.9145C0 11.6145 0.35 12.2395 0.885 12.6145C0.64 12.9545 0.5 13.3695 0.5 13.8145C0.5 14.5195 0.85 15.1395 1.385 15.5145C1.14 15.8545 1 16.2695 1 16.7145C1.00048 17.2152 1.18183 17.6989 1.51064 18.0765C1.83946 18.4541 2.29362 18.7002 2.7895 18.7695C2.8395 18.7825 2.8915 18.7895 2.945 18.7895H4.54C8.955 18.7895 9.24 18.7495 11.29 17.8945C11.61 17.7595 11.76 17.3945 11.625 17.0745C11.49 16.7545 11.12 16.6095 10.805 16.7395C8.928 17.523 8.842 17.5395 4.043 17.5395H3.075C2.62 17.5395 2.25 17.1695 2.25 16.7145C2.25 16.2595 2.62 15.8895 3.075 15.8895C3.24076 15.8895 3.39973 15.8236 3.51694 15.7064C3.63415 15.5892 3.7 15.4303 3.7 15.2645C3.7 15.0987 3.63415 14.9398 3.51694 14.8226C3.39973 14.7053 3.24076 14.6395 3.075 14.6395H2.575C2.12 14.6395 1.75 14.2695 1.75 13.8145C1.75 13.3595 2.12 12.9895 2.575 12.9895C2.74076 12.9895 2.89973 12.9236 3.01694 12.8064C3.13415 12.6892 3.2 12.5303 3.2 12.3645C3.2 12.1987 3.13415 12.0398 3.01694 11.9226C2.89973 11.8053 2.74076 11.7395 2.575 11.7395H2.075C1.62 11.7395 1.25 11.3695 1.25 10.9145C1.25 10.4595 1.62 10.0895 2.075 10.0895H2.575C2.74076 10.0895 2.89973 10.0236 3.01694 9.90644C3.13415 9.78923 3.2 9.63026 3.2 9.4645C3.2 9.29874 3.13415 9.13976 3.01694 9.02255C2.89973 8.90534 2.74076 8.8395 2.575 8.8395C2.12 8.8395 1.75 8.4695 1.75 8.0145C1.75 7.5595 2.12 7.1895 2.575 7.1895H3.835C5.8715 7.1895 7.113 7.1895 7.981 7.246C8.07827 7.26269 8.17811 7.25637 8.2725 7.22755C8.36689 7.19872 8.45322 7.14819 8.52457 7.08C8.59592 7.01181 8.65031 6.92785 8.68338 6.83486C8.71644 6.74187 8.72728 6.64243 8.715 6.5445L8.245 3.0895C8.135 2.4145 8.5 1.7745 9.145 1.5095C9.193 1.4905 9.236 1.508 9.2615 1.518L9.265 1.5195C9.305 1.5445 9.335 1.5795 9.34 1.5945L9.88 4.1345C10.115 5.2545 10.525 6.2845 11.095 7.1995ZM13.87 16.5345H18.27V10.0395H13.87V16.5345Z"
                fill="#76B60F"
              />
            </svg>
            <div>
              <h5 className>Free cancellation</h5>
              <h6 className style={{ marginTop: 2 }}>
                Full refund before July 23, 10:00 AM in local time of the car
              </h6>
            </div>
          </row>
          <row className="mt-l jcb">
            <p>$33.67 x 3 days</p>
            <p>$101.00</p>
          </row>
          <row className="mt-l jcb">
            <p>Trips fee</p>
            <p>$101.00</p>
          </row>
          <row className="mt-l jcb">
            <p>Sales tax</p>
            <p>$101.00</p>
          </row>
          <row className="mt-l jcb">
            <p>Prepaid fuel</p>
            <p>$101.00</p>
          </row>
          <row className="mt-l jcb">
            <p>900 total miles</p>
            <p>FREE</p>
          </row>
          <highlightbox className="mt-l jcb">
            <h5>Total</h5>
            <h5>$140.18</h5>
          </highlightbox>
          <line className="my-l" />
          <row>
            {" "}
            <h5 className>Extras</h5>
          </row>
          <row>
            <p className="my-l">
              These optional Extras are offered by this host and can help make
              your trip unique and memorable.
            </p>
          </row>
          <row>
            {" "}
            <h6 className>CONVINIENCE</h6>
          </row>
          <roundedcard className="highlight my-l">
            <row className="jcb">
              <h4>Prepaid refuel</h4>
              <p>$50/trip</p>
            </row>
            <row className="mt-m">
              <p>
                Save time, make drop-off a breeze, and avoid additional fees by
                adding this Extra, which allows you to return my car at any fuel
                level. Price includes up to a full tank of gas.
              </p>
            </row>
          </roundedcard>
          <row className="jce mt-1" style={{ marginBottom: "80px" }}>
            <h5 className="mt-1" style={{ color: "#76b60f" }}>
              Remove
            </h5>
          </row>
          <div class="md:hidden fixed bottom-0 left-0 right-0 bg-white p-4 border-t">
            <div class="flex justify-between items-center">
              <div>
                <span class="text-2xl font-bold">$50</span>
                <span class="text-gray-500">/ day</span>
              </div>
              <a href="/listings/1/book">
                <button class="greenButton text-white py-2 px-6 rounded-lg">
                  Book Now
                </button>
              </a>
            </div>
          </div>
        </mobilewrapper>
      </container>
    </div>
  );
}

export default Book;
